import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import contact from '../images/contact.png'; // yolunu kendi yapına göre ayarla

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
        {/* Contact Info */}
        <div className="text-center md:text-left">
          <h4 className="text-xl font-semibold mb-4">Kontaktiere uns</h4>
          <Link
            to="/angebot-form"
            className="inline-block no-underline bg-fuchsia-600 hover:bg-fuchsia-700 text-white px-4 py-2 rounded-full font-semibold transition mb-4"
          >
            Angebot Einholen
          </Link>
          <div className="mt-4 text-sm text-gray-300">
            <p>Email: info@netmoove.com</p>
            <p>Phone: +49 157 73537568</p>
          </div>
          <div className="flex justify-center md:justify-start gap-4 px-4 py-2 mt-4">
            <a href="https://facebook.com" className="hover:text-fuchsia-400 transition">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://twitter.com" className="hover:text-fuchsia-400 transition">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://instagram.com" className="hover:text-fuchsia-400 transition">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>

        {/* Contact Image */}
        <div className="flex justify-center">
          <img src={contact} alt="Contact" className="rounded-xl shadow-lg w-full max-w-xs object-cover" />
        </div>

        {/* Services List */}
        <div className="text-center md:text-left">
          <h5 className="text-xl font-semibold mb-4">Dienstleistungen</h5>
          <ul className="space-y-2 text-gray-300 text-sm">
            {[
              "Softwareentwicklung",
              "Web Entwicklung",
              "UX/UI Dienstleistungen",
              "Business Analysis",
              "Mobile-App-Entwicklung",
              "Qualitätssicherung und Testen",
            ].map((service, i) => (
              <li key={i} className="hover:text-fuchsia-400 transition">
                {service}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center mt-12 text-sm text-gray-500 border-t border-gray-700 pt-6">
        © {new Date().getFullYear()} NET MOOVE. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
